// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__4JQWV","title":"styles_title__0hm0l","body":"styles_body__co5NG","close":"styles_close__TAdik"};